module.exports = __webpack_public_path__ + "img/img_hezuo_7@2x.a9a86645.png";